export default {
	header: {
		self: {},
		items: [
			{
				title: "Google Play",
				root: true,
				alignment: "left",
				link: "https://play.google.com/console/u/0/developers/8222657441807507564/app/4974318662411094913/app-dashboard?timespan=thirtyDays&showKpiMenu=null",
			},
			{
				title: "Apple Store",
				root: true,
				alignment: "left",
				link: "https://appstoreconnect.apple.com/analytics/app/d30/1539926395/overview",
			},
		]
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				icon: "fas fa-tachometer-alt",
				page: "dashboard",
				bullet: "dot"
			},
			{
				title: "Base Operacional",
				root: true,
				bullet: "dot",
				icon: "fas fa-city",
				submenu: [
					{
						title: "Embarcadoras",
						bullet: "dot",
						permission: "admin.empresa.list",
						page: "embarcadora"
					},
					{
						title: "Transportadoras",
						bullet: "dot",
						permission: "admin.empresa.list",
						page: "transportadora"
					},
					{
						title: "Motoristas",
						bullet: "dot",
						permission: "admin.caminhoneiro.list",
						page: "motorista"
					},
					{
						title: "Proprietários ANTT",
						bullet: "dot",
						permission: "admin.transportador.list",
						page: "proprietario-antt"
					},
					{
						title: "Tração",
						bullet: "dot",
						page: "tracao"
					},
					{
						title: "Carroceria",
						bullet: "dot",
						page: "carroceria"
					},
				]
			},
			{
				title: "Parâmetros Operacionais",
				root: true,
				bullet: "dot",
				icon: "fas fa-boxes",
				submenu: [
					{
						title: "Produtos",
						bullet: "dot",
						page: "produto",
						permission: "admin.produto.list"
					},
					{
						title: "Tipos de carga",
						bullet: "dot",
						page: "tipo-carga",
						permission: "admin.tipo_carga.list"
					},
					{
						title: "Categorias ANTT",
						bullet: "dot",
						page: "categoria-carga-antt",
						permission: "admin.categoria_carga_antt.list"
					},
					{
						title: "Composição Veicular",
						bullet: "dot",
						page: "composicao-veicular",
						permission: "admin.tipo_composicao_veicular.list"
					},
				]
			},
			{
				title: "Torre de Controle",
				root: true,
				bullet: "dot",
				icon: "fas fa-broadcast-tower",
				submenu: [
					{
						title: "Monitoramento",
						bullet: "dot",
						page: "torre/monitoramento"
					},
				]
			},
			{
				title: "Painel de Ofertas",
				root: true,
				bullet: "dot",
				icon: "fas fa-comments-dollar",
				submenu: [
					{
						title: "Gestão de Ofertas",
						bullet: "dot",
						page: "painel-oferta"
					},
					{
						title: "Viagens",
						bullet: "dot",
						page: "painel-oferta/viagens"
					},
					{
						title: "Projeção de Fluxo",
						bullet: "dot",
						page: "painel-oferta/projecao"
					},
				]
			},
			{
				title: "Gestão de Programações",
				root: true,
				bullet: "dot",
				icon: "fas fa-clipboard-list",
				submenu: [
					{
						title: "Programações",
						bullet: "dot",
						permission: "admin.programacao.list",
						page: "gestao-programacoes/programacoes"
					},
					{
						title: "Lotes",
						bullet: "dot",
						permission: "admin.lote.list",
						page: "gestao-programacoes/lotes"
					},
				]
			},
			{
				title: "Gestão de Pátios",
				root: true,
				bullet: "dot",
				icon: "fas fa-parking",
				submenu: [
					{
						title: "Dashboard",
						bullet: "dot",
						page: "dashboard-patio"
					},
					{
						title: "Confirmação via PIX",
						bullet: "dot",
						permission: "admin.confirmacao_pix.list",
						page: "pix"
					},
					{
						title: "Pátios",
						bullet: "dot",
						permission: "admin.patio.list",
						page: "patio"
					},
					{
						title: "Serviços",
						bullet: "dot",
						page: "servico",
						submenu: [
							{
								title: "Limpeza",
								bullet: "dot",
								permission: "admin.servico_limpeza.list",
								page: "servico/limpeza"
							},
							{
								title: "Estacionamento",
								bullet: "dot",
								permission: "admin.servico_estacionamento.list",
								page: "servico/estacionamento"
							},
							{
								title: "Classificação de Produto",
								bullet: "dot",
								permission: "admin.classificacao_produto.list",
								page: "servico/classificacao-produto"
							},
						]
					},
					{
						title: "Desconto",
						bullet: "dot",
						permission: "admin.desconto.list",
						page: "desconto"
					},
					{
						title: "Agendamentos",
						bullet: "dot",
						submenu: [
							{
								title: "Limpeza",
								bullet: "dot",
								page: "agendamento/limpeza"
							},
							{
								title: "Estacionamento",
								bullet: "dot",
								permission: "admin.agendamento_estacionamento.list",
								page: "agendamento/estacionamento"
							},
							{
								title: "Classificação de Produto",
								bullet: "dot",
								permission: "admin.classificacao_produto.list",
								page: "agendamento/classificacao-produto"
							},
						]
					},
					{
						title: "Vagas Mensais",
						bullet: "dot",
						permission: "admin.vagas_mensais.list",
						page: "vaga-mensal"
					},
					{
						title: "Relatórios",
						bullet: "dot",
						submenu: [
							{
								title: "Financeiro",
								bullet: "dot",
								permission: "admin.relatorio.list",
								page: "relatorio-patio/relatorio01"
							},
							{
								title: "Cobrança",
								bullet: "dot",
								permission: "admin.relatorio.list",
								page: "relatorio-patio/relatorio02"
							},
						]
					},
				]
			},
			{
				title: "Orçamentos",
				root: true,
				icon: "fas fa-file-contract",
				permission: "admin.orcamento.list",
				page: "orcamento",
				bullet: "dot"
			},
			{
				title: "Avaliações",
				root: true,
				bullet: "dot",
				icon: "fas fa-star-half-alt",
				submenu: [
					{
						title: "Embarcadoras",
						bullet: "dot",
						permission: "admin.avaliacao.list",
						page: "avaliacao/embarcadora"
					},
					{
						title: "Transportadoras",
						bullet: "dot",
						permission: "admin.avaliacao.list",
						page: "avaliacao/transportadora"
					},
				]
			},
			{
				title: "Relatórios",
				root: true,
				bullet: "dot",
				icon: "fas fa-chart-pie",
				submenu: [
					{
						title: "Cadastros Não Finalizados",
						bullet: "dot",
						permission: "admin.relatorio.list",
						page: "relatorio/relatorio01"
					},
					{
						title: "Carga x Transportadora",
						bullet: "dot",
						permission: "admin.relatorio.list",
						page: "relatorio/relatorio02"
					},
					{
						title: "Cargas x Região",
						bullet: "dot",
						permission: "admin.relatorio.list",
						page: "relatorio/relatorio03"
					},
					{
						title: "Produtos x Região",
						bullet: "dot",
						permission: "admin.relatorio.list",
						page: "relatorio/relatorio04"
					},
				]
			},
			{
				title: "Administradores",
				root: true,
				icon: "fas fa-user-shield",
				permission: "admin.admin_usuario.list",
				page: "admin",
				bullet: "dot"
			},
			{
				title: "Grupos de Acesso",
				root: true,
				icon: "fas fa-layer-group",
				permission: "admin.admin_group.list",
				page: "group",
				bullet: "dot",
			},
			{
				title: "Código de Acesso Motorista",
				root: true,
				icon: "fas fa-key",
				page: "codigo-acesso-motorista",
				bullet: "dot"
			},
		]
	}
};
